export default __webpack_public_path__ + "static/media/ethworks-logo.85eb413e.svg";